document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('deferred-media.media.no-js-hidden').forEach(function (dm) {
    var tpl = dm.querySelector('template');
    if (tpl && !dm.querySelector('video') && tpl.content) {
      dm.appendChild(tpl.content.cloneNode(true));
    }
    var poster = dm.closest('.product__deferred_media')?.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';
  });

  function prep(v) {
    if (!v) return;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', 'true');
    v.removeAttribute('controls');
    v.setAttribute('controlslist', 'nodownload noplaybackrate');
    v.setAttribute('disablepictureinpicture', '');
  }

  function tryPlay(v) {
    if (!v) return;
    prep(v);
    v.play().catch(function () { });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) tryPlay(v); else v.pause();
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.product__media video').forEach(function (v) {
    prep(v);
    io.observe(v);
  });

  var root = document.querySelector('.product__media-list--auto-enabled');
  if (root) {
    var handle = function () {
      root.querySelectorAll('.swiper-slide').forEach(function (slide) {
        var v = slide.querySelector('video'); if (!v) return;
        if (slide.classList.contains('swiper-slide-active')) tryPlay(v);
        else v.pause();
      });
    };
    new MutationObserver(handle).observe(root, { attributes: true, subtree: true, attributeFilter: ['class'] });
    handle();
  }
});


(function () {
  var openers = document.querySelectorAll('.product__modal-opener');
  openers.forEach(function (opener) {
    opener.removeAttribute('data-modal');
    opener.classList.add('modal-disabled');

    opener.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    opener.addEventListener('click', function (e) {
      if (e.target.closest('.product__media-toggle') || e.target.closest('.product__media-icon')) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    var toggle = opener.querySelector('.product__media-toggle');
    if (toggle) {
      toggle.setAttribute('tabindex', '-1');
      toggle.setAttribute('aria-hidden', 'true');
      toggle.disabled = true;
    }
  });
})();

